import React from "react";
import styles from "./task-list-header.module.css";
import { Text } from "@mantine/core";

export const TaskListHeader = ({ headerHeight, fontFamily, fontSize, rowWidth }) => {
    return (
        <div
            className={styles.ganttTable}
            style={{
                fontFamily: fontFamily,
                fontSize: fontSize,
                borderBottom: '1px solid #e9ecef',
                backgroundColor: '#EBF1F4',
            }}
        >
            <div
                className={`${styles.ganttTable_Header}`}
                style={{
                    height: headerHeight - 2,
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '6px',
                    paddingBottom: '6px'
                }}
            >
                <div
                    className={styles.ganttTable_HeaderItem}
                    style={{
                        minWidth: '250px',
                        maxWidth: '250px',
                        paddingLeft: '5px',
                    }}
                >
                    <Text c="dimmed" size="xs" fw={600} tt="uppercase" ls={0.5}>Task</Text>
                </div>

                <div
                    className={styles.ganttTable_HeaderItem}
                    style={{
                        minWidth: '100px',
                        maxWidth: '100px',
                        textAlign: 'center',
                        borderLeft: '1px solid #e9ecef',
                    }}
                >
                    <Text c="dimmed" size="xs" fw={600} tt="uppercase" ls={0.5}>Assigned</Text>
                </div>

                <div
                    className={styles.ganttTable_HeaderItem}
                    style={{
                        minWidth: '150px',
                        maxWidth: '150px',
                        textAlign: 'center',
                        borderLeft: '1px solid #e9ecef',
                    }}
                >
                    <Text c="dimmed" size="xs" fw={600} tt="uppercase" ls={0.5}>Status</Text>
                </div>

                <div
                    className={styles.ganttTable_HeaderItem}
                    style={{
                        minWidth: '130px',
                        maxWidth: '130px',
                        textAlign: 'center',
                        borderLeft: '1px solid #e9ecef',
                    }}
                >
                    <Text c="dimmed" size="xs" fw={600} tt="uppercase" ls={0.5}>Due Date</Text>
                </div>
            </div>
        </div>
    );
};